module.exports = __webpack_public_path__ + "img/inst-3.b482e5fb.png";